import React from "react";
import cards from "../src/Assests/Rise Images/sectionTow.png";
import second from "../src/Assests/Rise Images/sectionThree.png"

export default function SectionTwo() {
  return (
    <>
      <div className="Section-tow container d-flex">
        <div className="continer-fulid w-50 img-side">
          <img style={{ width: "100%" }} src={cards} />
        </div>
        <div className="container text-side w-50 d-flex  p-5 flex-column justify-content-center">
          <h2 style={{ fontWeight: "bolder", color: "#014651" }}>
            About <span style={{ color: "#ff7548"}}>the card</span>{" "}
          </h2>
          <p style={{color:"#777777"}} >
          {/* About the card */}
            Introducing our versatile cobranded prepaid card, a multifunctional 
            solution catering to the needs of university students within gated 
            communities.
            
            <br/>           
            <br/>
            Seamlessly doubling as a university ID/Access card and 
            payment card, it streamlines campus life while aligning with 
            institutional requirements by inserting the student mobile number & e-mail. 
            With no bank account needed, users enjoy hassle-free access. Stay 
            informed with Transactions SMS notifications and enjoy free 
            purchase and online transactions.
            <br/>

            <br/>
            Plus, withdraw cash from ATMs 
            and load your card via ATM machines, IPN, and peer to peer 
            transfers through mobile app. Secure payments ensure peace of mind, 
            while our mobile app allows efficient card management, transaction viewing, PIN changes, 
            and card blocking/unblocking.

          </p>
        </div>
      </div>
<br/>
<br/>

      {/* section 3 */}
      <div className="Section-tow container sec-3 d-flex justify-content-center">
        
        <div className="container text-side w-50 d-flex  py-5 px-0 flex-column">
          <h2 style={{ fontWeight: "bolder", color: "#014651" }}>
            About <span style={{ color: "#ff7548"}}>the Application</span>{" "}
          </h2>
          
          <p style={{color:"#777777"}} >
          Our application provides a comprehensive range of features aimed at enhancing financial management, creating a joyful experience by integrating youth requirements with secure payment methods.
          Strike a balance between the academic and entertainment experience, adding lots of appealing features gaming, bills payment, gift vouchers and lots more to come.
            
          <br></br><br></br>Spend more earn more Strong loyalty programs in all favorite youth stores.
            <br/>            <br/>

            Buying Gaming vouchers, send & receive gift vouchers. “Game together stays together”. <br>
            </br><br></br>
            Creating a strong youth community sending & receiving money from your friends “together we are strong”.
            <br/>
            <br/>
            Stay Connected Seamlessly recharging/paying your bills.
          </p>
        </div>
        
        <div className="continer-fulid w-50 img-side">
        <br/>
        <br/>
          <img style={{ width: "100%" }} src={second} />
        </div>
      </div>
    </>
  );
}
